import axios from '../../../build/http-requests/axios-common'

export default {
  state: {

  },

  mutations: {
  },

  actions: {
    getEntities: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/auditLog/entities').then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getAudit: ({ commit }, auditId) => {
      return new Promise((resolve, reject) => {
        axios.get('/auditLog/audits', { params: { auditId: auditId } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/auditLog.js